{
    "valuesLabels": {
        "0": "policy.insured-trips.it-status.all",
        "4": "policy.insured-trips.it-status.active",
        "5": "policy.insured-trips.it-status.canceled",
        "12": "policy.insured-trips.it-status.overdue"
    },
    "defaultValue": 4
}